export const PAYMENT_METHOD__DEFAULT_CARD = 'defaultCard';
export const PAYMENT_METHOD__ONE_TIME_CARD_PAYMENT = 'onetimeCardPayment';
export const PAYMENT_METHOD__REPLACE_CARD = 'replaceCard';
